import { MAJOR_APPLIANCES_UPPERCASE } from '../../../constants';

export const getHdppDisplayedPreloadEvent = () => {
  return {
    eventMode: 'preload',
    category: {
      primaryCategory: 'hdpp content'
    },
    eventInfo: {
      eventName: 'hdpp display'
    },
    item: [{
      productInfo: {
        displayedProtectionPlan: true
      }
    }]
  };
};

export const hasPathNameChanged = ({ location, routerChangeEvent }) => {
  const previousPathName = location?.pathname;
  const newPathName = routerChangeEvent?.output?.location?.pathname;
  return previousPathName !== newPathName;
};

// Appliance PIP > Out of Stock on PIP: product[0].productInfo.availabilityStatus.inStockApp ("true"|"false")
export const setInStockApp = ( products, inStockApp ) => {
  const productInfo = Array.isArray( products ) ? products[ 0 ]?.productInfo : null;
  if ( !productInfo || productInfo.productType !== MAJOR_APPLIANCES_UPPERCASE ) return;

  productInfo.availabilityStatus = {
    ...productInfo.availabilityStatus || {},
    inStockApp: String( inStockApp )
  };
};
